import { Divider } from "@mui/material";
import React from "react";
import {useAppDispatch, useAppSelector } from "../../../State/Store";
import { useEffect } from "react";
import { findUserCartHandler } from "../../../State/customer/CartSlice";


export const PricingCart = () => {
  const {cart}=useAppSelector(store=>store)
  const dispatch = useAppDispatch()
  useEffect(() => { 
    dispatch(findUserCartHandler())
   },[dispatch])
  
  return (
    <>
      <div className="space-y-3 p-5">
        <div className="flex justify-between items-center">
          <span>Subtotal</span>
          <span>{cart?.cart?.totalMrpPrice}€</span>
        </div>

        <div className="flex justify-between items-center">
          <span>Discount</span>
          <span>{cart?.cart?.discount}%</span>
        </div>
        <div className="flex justify-between items-center">
          <span>Shipping</span>
          <span>Free</span>
        </div>
        <div className="flex justify-between items-center">
          <span>Platform fee</span>
          <span>Free</span>
        </div>
      </div>
        <Divider />
        <div className="flex justify-between items-center p-5 text-primary font-semibold text-xl ">
          <span>Total</span>
          <span>{cart.cart?.totalSellingPrice}€</span>
        </div>
    </>
  );
};
